import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { connect } from 'react-redux';
import { hot } from 'react-hot-loader/root';

import moment from 'moment';

import { Dropdown, Typography } from 'antd';

import { DownOutlined, FormOutlined, EyeOutlined, TeamOutlined, CalendarOutlined } from '@ant-design/icons';

import Overview from '../../components/overview';

import withErrorHandler from '../../../../hoc/withErrorHandler';
import axios from '../../../../shared/axios/axios';
import newAxios from '../../../../shared/axios/new-api-axios';

import { pipelinePagesTypes } from '../../../../shared/constants/enums/pipelinePagesTypes';
import { serviceRequestTypes } from '../../../../shared/constants/enums/serviceRequestTypes';
import { siteUrls } from '../../../../shared/constants/siteUrls';
import {
  generateColumns,
  generateStageColumns,
  generateCustomTypeColumns,
  loadSingleBucket,
  loadData,
} from '../../helpers/pipelines-overview-helper';

import { getServiceRequestStatuses } from '../../../../shared/store/actions';
import {
  changeServiceRequestStatus,
  getServiceRequestPipelinesControlConfig,
  getServiceRequestPipelinesStages,
  getServiceRequestPipelinesCustomTypes,
  changeServiceRequestStage,
  changeServiceRequestCustomType,
  saveServiceRequestPipelinesControlConfig,
} from '../../store/actions';

import { serviceRequestStatusOpts } from '../../../../shared/constants/lookupListConstants';
import * as sharedActions from '../../../../shared/store/actions';

import './service-requests-overview-styles.less';

import { userTypes } from '../../../../shared/constants/enums';

import { isEmpty } from 'lodash';

let root;

const ServiceRequestsOverview = ({ rootContainer }) => {
  const [columns, setColumns] = useState(null);
  const [columnsFromBackend, setColumnsFromBackend] = useState(null);
  const [filters, setFilters] = useState(null);
  const [serviceRequestType, setServiceRequestType] = useState(pipelinePagesTypes.ServiceRequestsOverview);
  const [loading, setLoading] = useState(false);

  const userInfo = useSelector((state) => state.shared.userInfo);

  const dispatch = useDispatch();

  const { serviceRequestStatuses, serviceRequestStatusesLoading } = useSelector((state) => state.shared);
  const { serviceRequestPipelinesControlConfig, serviceRequestPipelinesControlConfigLoading } = useSelector(
    (state) => state.serviceRequestsPipelines,
  );
  const { serviceRequestPipelinesStages, serviceRequestPipelinesStagesLoading } = useSelector((state) => state.serviceRequestsPipelines);
  const { serviceRequestPipelinesCustomTypes, serviceRequestPipelinesCustomTypesLoading } = useSelector((state) => state.serviceRequestsPipelines);

  //#region React Hooks

  useEffect(() => {
    root = rootContainer;
    dispatch(getServiceRequestPipelinesControlConfig(serviceRequestType));

    dispatch(getServiceRequestPipelinesStages({ refreshStages: false }));
    dispatch(getServiceRequestPipelinesCustomTypes({ refreshCustomTypes: false }));
    dispatch(getServiceRequestStatuses());

    dispatch(sharedActions.getUserInfo());
  }, []);

  useEffect(() => {
    if (serviceRequestType === pipelinePagesTypes.ServiceRequestsOverview && !serviceRequestStatusesLoading && serviceRequestStatuses) {
      const colsFromBackend = generateColumns(serviceRequestStatuses, 'value', true);

      setColumns(colsFromBackend);
      setColumnsFromBackend(colsFromBackend);
    }
  }, [serviceRequestStatuses, serviceRequestType]);

  useEffect(() => {
    if (
      serviceRequestType === pipelinePagesTypes.ServiceRequestsStagesOverview &&
      !serviceRequestPipelinesControlConfigLoading &&
      serviceRequestPipelinesControlConfig
    ) {
      const stages = (serviceRequestPipelinesStages?.length && serviceRequestPipelinesStages.filter((s) => !isEmpty(s))) || [];

      const colsFromBackend = generateStageColumns(serviceRequestPipelinesControlConfig.columns, stages);

      setColumns(colsFromBackend);
      setColumnsFromBackend(colsFromBackend);
    }
  }, [serviceRequestPipelinesStages, serviceRequestType, serviceRequestPipelinesControlConfig]);

  useEffect(() => {
    if (
      serviceRequestType === pipelinePagesTypes.ServiceRequestsCustomTypesOverview &&
      !serviceRequestPipelinesControlConfigLoading &&
      serviceRequestPipelinesControlConfig
    ) {
      const customTypes = (serviceRequestPipelinesCustomTypes?.length && serviceRequestPipelinesCustomTypes.filter((s) => !isEmpty(s))) || [];

      const colsFromBackend = generateCustomTypeColumns(serviceRequestPipelinesControlConfig.columns, customTypes);

      setColumns(colsFromBackend);
      setColumnsFromBackend(colsFromBackend);
    }
  }, [serviceRequestPipelinesCustomTypes, serviceRequestType, serviceRequestPipelinesControlConfig]);

  useEffect(() => {
    if (!!columnsFromBackend && !!userInfo) {
      let tempFilters = {};

      if (userInfo.userType === userTypes.Agent) {
        tempFilters = { assignedTo: 1, agentIds: [userInfo.userId] };
      }

      loadAllData(true, tempFilters);
    }
  }, [columnsFromBackend, userInfo]);

  //#endregion React Hooks

  const loadAllData = async (resetPaging, filters) => {
    if (columnsFromBackend) {
      setFilters(filters);

      setLoading(true);

      const updatedColumns = await loadData(columnsFromBackend, resetPaging, filters, 'getServiceRequests', serviceRequestType).finally(() => {
        setLoading(false);
      });

      setColumns(updatedColumns);
    }
  };

  const refresh = () => {
    loadAllData(true, filters);
  };

  const clearColumns = () => {
    setColumns(null);
    setColumnsFromBackend(null);
  };

  const handleChangeStatus = (sourceCol, destColumn, item) => {
    const updatedColumns = { ...columns };

    Object.keys(updatedColumns).forEach((columnKey) => {
      if (updatedColumns[columnKey].name === sourceCol.name || updatedColumns[columnKey].name === destColumn.name) {
        updatedColumns[columnKey].loading = true;
      }
    });

    setColumns(updatedColumns);

    dispatch(changeServiceRequestStatus({ id: item.id, newStatus: destColumn.status, serviceRequestType: item.serviceRequestType })).then(() => {
      handleLoadSingleBucketData(destColumn, true);
      handleLoadSingleBucketData(sourceCol, true);
    });
  };

  const handleLoadSingleBucketData = async (column, resetPage) => {
    const updatedColumns = await loadSingleBucket(columns, column, resetPage, filters, 'getServiceRequests', serviceRequestType);
    setColumns(updatedColumns);
  };

  const renderActionsMenu = (item) => {
    const editUrl = siteUrls.getServiceRequestEditUrl(serviceRequestPipelinesControlConfig?.isMomentumEnabled, item.serviceRequestType, item.id);
    const detailsUrl = siteUrls.getServiceRequestDetailsUrl(
      serviceRequestPipelinesControlConfig?.isMomentumEnabled,
      item.serviceRequestType,
      item.id,
    );

    const menu = [
      {
        key: '1',
        label: (
          <a href={editUrl}>
            <FormOutlined style={{ marginRight: '8px' }} />
            Edit
          </a>
        ),
      },
      {
        key: '2',
        label: (
          <a href={detailsUrl}>
            <EyeOutlined style={{ marginRight: '8px' }} />
            Details
          </a>
        ),
      },
    ];

    return (
      <Dropdown menu={{ items: menu }} trigger={['click']} getPopupContainer={rootContainer} placement="bottom">
        <DownOutlined style={{ fontSize: '10px' }} />
      </Dropdown>
    );
  };

  const renderBucketItem = (item) => {
    return (
      <div className="pipeline-item">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
          <span title={'Insured'} className="text-ellipsis">
            {item.insured && item.insured.name ? (
              <a
                title={item.insured.name.trim()}
                href={siteUrls.getTruckingCompanyDetailsUrl(
                  serviceRequestPipelinesControlConfig?.isMomentumEnabled,
                  item.insured.id,
                  item.insured.type,
                )}
              >
                {item.insured.name.trim()}
              </a>
            ) : (
              'N/A'
            )}
          </span>

          {renderActionsMenu(item)}
        </div>

        {item.serviceRequestType === serviceRequestTypes.VehicleTransfer ? (
          <p style={{ margin: '5px 0', fontSize: '12px' }}>
            <Typography.Text type="secondary">Is car under Insured: {item.isCarUnderInsuredName ? 'Yes' : 'No'}</Typography.Text>
          </p>
        ) : null}

        {!!item.subject ? (
          <p style={{ margin: '5px 0', fontSize: '12px' }}>
            <Typography.Text type="secondary">{item.subject}</Typography.Text>
          </p>
        ) : null}

        <div title={'Assigned agents'} style={{ margin: '5px 0', fontSize: '12px' }}>
          <TeamOutlined style={{ marginRight: '5px' }} />
          {item.assignedAgents && item.assignedAgents.length
            ? item.assignedAgents.map((agent, index) => {
                return (
                  <span key={agent.id}>
                    <a href={siteUrls.getAgentDetailsUrl(serviceRequestPipelinesControlConfig?.isMomentumEnabled, agent.id)}>
                      {`${agent.firstName} ${agent.lastName}`.trim()}
                    </a>
                    {item.assignedAgents.length - 1 !== index ? ', ' : ' '}
                  </span>
                );
              })
            : 'N/A'}
        </div>
        {item.status && serviceRequestType !== pipelinePagesTypes.ServiceRequestsOverview ? (
          <div title={'Status'} style={{ margin: '5px 0', fontSize: '12px' }}>
            <Typography.Text style={{ marginRight: '5px' }}>Status:</Typography.Text>
            <Typography.Text type="secondary">{serviceRequestStatusOpts.find((s) => s.value === item.status)?.text}</Typography.Text>
          </div>
        ) : null}
        {item.stage && serviceRequestType !== pipelinePagesTypes.ServiceRequestsStagesOverview ? (
          <div title={'Stage'} style={{ margin: '5px 0', fontSize: '12px' }}>
            <Typography.Text style={{ marginRight: '5px' }}>Stage:</Typography.Text>
            <Typography.Text type="secondary">{item.stage}</Typography.Text>
          </div>
        ) : null}
        {item.customType && serviceRequestType !== pipelinePagesTypes.ServiceRequestsCustomTypesOverview ? (
          <div title={'Custom type'} style={{ margin: '5px 0', fontSize: '12px' }}>
            <Typography.Text style={{ marginRight: '5px' }}>Custom type:</Typography.Text>
            <Typography.Text type="secondary">{item.customType}</Typography.Text>
          </div>
        ) : null}
        {!!item.dueDate ? (
          <div title={'Due date'} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '5px 0', fontSize: '11px', alignItems: 'center' }}>
            <CalendarOutlined style={{ marginRight: '5px' }} />
            <Typography.Text type="secondary">{moment(item.dueDate).format('MMM DD YYYY')}</Typography.Text>
          </div>
        ) : null}
      </div>
    );
  };

  const onChangeServiceRequestType = (type) => {
    setServiceRequestType(type);
    if (type === pipelinePagesTypes.ServiceRequestsCustomTypesOverview || type === pipelinePagesTypes.ServiceRequestsStagesOverview) {
      dispatch(getServiceRequestPipelinesControlConfig(type));
    }
  };

  const handleUpdateColumnsState = (updatedColumns) => {
    setColumns(updatedColumns);
  };

  const saveControlConfiguration = (columnsConfig) => {
    const newControlConfig = { ...serviceRequestPipelinesControlConfig, ...{ columns: columnsConfig } };

    dispatch(saveServiceRequestPipelinesControlConfig(newControlConfig, serviceRequestType));
  };

  const handleChangeStage = (sourceCol, destColumn, item) => {
    const updatedColumns = { ...columns };

    Object.keys(updatedColumns).forEach((columnKey) => {
      if (updatedColumns[columnKey].name === sourceCol.name || updatedColumns[columnKey].name === destColumn.name) {
        updatedColumns[columnKey].loading = true;
      }
    });

    setColumns(updatedColumns);

    dispatch(changeServiceRequestStage({ id: item.id, newStage: destColumn.stage, serviceRequestType: item.serviceRequestType })).then(() => {
      handleLoadSingleBucketData(destColumn, true);
      handleLoadSingleBucketData(sourceCol, true);
    });
  };

  const handleChangeCustomType = (sourceCol, destColumn, item) => {
    const updatedColumns = { ...columns };

    Object.keys(updatedColumns).forEach((columnKey) => {
      if (updatedColumns[columnKey].name === sourceCol.name || updatedColumns[columnKey].name === destColumn.name) {
        updatedColumns[columnKey].loading = true;
      }
    });

    setColumns(updatedColumns);

    dispatch(changeServiceRequestCustomType({ id: item.id, newCustomType: destColumn.customType, serviceRequestType: item.serviceRequestType })).then(
      () => {
        handleLoadSingleBucketData(destColumn, true);
        handleLoadSingleBucketData(sourceCol, true);
      },
    );
  };

  const refreshStagesConstrolConfiguration = () => {
    if (serviceRequestType === pipelinePagesTypes.ServiceRequestsStagesOverview) {
      dispatch(getServiceRequestPipelinesStages({ refreshStages: true }));
    } else if (serviceRequestType === pipelinePagesTypes.ServiceRequestsCustomTypesOverview) {
      dispatch(getServiceRequestPipelinesCustomTypes({ refreshCustomTypes: true }));
    }
  };

  return (
    <>
      {serviceRequestType === pipelinePagesTypes.ServiceRequestsOverview ? (
        <Overview
          configuratorEnabled={false}
          columns={columns}
          renderBucketItem={renderBucketItem}
          type={serviceRequestType}
          userInfo={userInfo}
          isLoading={serviceRequestStatusesLoading || loading}
          refresh={refresh}
          changeStatus={handleChangeStatus}
          loadSingleBucketData={handleLoadSingleBucketData}
          rootContainer={rootContainer}
          fetchData={loadAllData}
          onPipelineTypeChange={(type) => onChangeServiceRequestType(type)}
          isMomentumEnabled={serviceRequestPipelinesControlConfig?.isMomentumEnabled}
          canViewOnlyAssigned={serviceRequestPipelinesControlConfig?.canViewOnlyAssigned}
        />
      ) : serviceRequestType === pipelinePagesTypes.ServiceRequestsStagesOverview ? (
        <Overview
          configuratorEnabled={true}
          columns={columns}
          renderBucketItem={renderBucketItem}
          type={serviceRequestType}
          userInfo={userInfo}
          isLoading={serviceRequestPipelinesStagesLoading || loading}
          refresh={refresh}
          changeStatus={handleChangeStage}
          loadSingleBucketData={handleLoadSingleBucketData}
          updateColumnsState={handleUpdateColumnsState}
          saveControlConfiguration={saveControlConfiguration}
          rootContainer={rootContainer}
          fetchData={loadAllData}
          onPipelineTypeChange={(type) => onChangeServiceRequestType(type)}
          refreshConstrolConfiguration={() => refreshStagesConstrolConfiguration()}
          isMomentumEnabled={serviceRequestPipelinesControlConfig?.isMomentumEnabled}
          canViewOnlyAssigned={serviceRequestPipelinesControlConfig?.canViewOnlyAssigned}
        />
      ) : serviceRequestType === pipelinePagesTypes.ServiceRequestsCustomTypesOverview ? (
        <Overview
          configuratorEnabled={true}
          columns={columns}
          renderBucketItem={renderBucketItem}
          type={serviceRequestType}
          userInfo={userInfo}
          isLoading={serviceRequestPipelinesCustomTypesLoading || loading}
          refresh={refresh}
          changeStatus={handleChangeCustomType}
          loadSingleBucketData={handleLoadSingleBucketData}
          updateColumnsState={handleUpdateColumnsState}
          saveControlConfiguration={saveControlConfiguration}
          rootContainer={rootContainer}
          fetchData={loadAllData}
          onPipelineTypeChange={(type) => onChangeServiceRequestType(type)}
          refreshConstrolConfiguration={() => refreshStagesConstrolConfiguration()}
          isMomentumEnabled={serviceRequestPipelinesControlConfig?.isMomentumEnabled}
          canViewOnlyAssigned={serviceRequestPipelinesControlConfig?.canViewOnlyAssigned}
        />
      ) : null}
    </>
  );
};

export default connect(null, null)(hot(withErrorHandler(ServiceRequestsOverview, axios, root, newAxios)));
